import type { Goal, MoodInsight, StrengthMilestone } from '../types'

export const strengthMilestones: StrengthMilestone[] = [
  {
    id: 'squat-bodyweight',
    label: { 'pt-BR': 'Agachamento no peso corporal', 'en-US': 'Bodyweight squat' },
    detail: { 'pt-BR': '62,4 kg alcançados', 'en-US': '62.4 kg reached' },
    reached: true,
  },
  {
    id: 'deadlift-2x',
    label: { 'pt-BR': 'Terra em 2× o peso corporal', 'en-US': 'Deadlift at 2× bodyweight' },
    detail: { 'pt-BR': '120 de 125 kg', 'en-US': '120 of 125 kg' },
    reached: false,
  },
  {
    id: 'four-weeks',
    label: { 'pt-BR': '4 semanas sem perder treino', 'en-US': '4 weeks without a missed session' },
    detail: { 'pt-BR': '3 de 4 semanas', 'en-US': '3 of 4 weeks' },
    reached: false,
  },
]

export const moodInsights: MoodInsight[] = [
  {
    id: 'training-mood',
    text: {
      'pt-BR': 'Nos dias que você treina, seu humor tende a melhorar.',
      'en-US': 'On days you train, your mood tends to improve.',
    },
    basis: {
      'pt-BR': 'Observado em 24 de 31 dias com movimento registrado.',
      'en-US': 'Seen in 24 of 31 days with recorded movement.',
    },
  },
  {
    id: 'sleep-energy',
    text: {
      'pt-BR': 'Seu sono está relacionado à sua energia no dia seguinte.',
      'en-US': 'Your sleep relates to your energy the next day.',
    },
    basis: {
      'pt-BR': 'Comparação entre noites com e sem o hábito de sono marcado.',
      'en-US': 'Comparing nights with and without the sleep habit checked.',
    },
  },
  {
    id: 'hydration-dip',
    text: {
      'pt-BR': 'Hidratação é o hábito que você mais deixa para o fim do dia.',
      'en-US': 'Hydration is the habit you most often leave for late in the day.',
    },
    basis: {
      'pt-BR': 'Baseado na ordem dos seus checks nas últimas 4 semanas.',
      'en-US': 'Based on your check order over the last 4 weeks.',
    },
  },
]

export const goals: Goal[] = [
  {
    id: 'perfect-days',
    title: {
      'pt-BR': 'Dias perfeitos no mês',
      'en-US': 'Perfect days this month',
    },
    current: 11,
    target: 18,
    unit: { 'pt-BR': 'dias', 'en-US': 'days' },
    deadline: { 'pt-BR': 'até 30 de setembro', 'en-US': 'by September 30' },
  },
  {
    id: 'workouts',
    title: { 'pt-BR': 'Treinos por semana', 'en-US': 'Workouts per week' },
    current: 4,
    target: 5,
    unit: { 'pt-BR': 'treinos', 'en-US': 'workouts' },
  },
  {
    id: 'sleep',
    title: {
      'pt-BR': 'Noites com 7h ou mais',
      'en-US': 'Nights with 7h or more',
    },
    current: 19,
    target: 28,
    unit: { 'pt-BR': 'noites', 'en-US': 'nights' },
    deadline: { 'pt-BR': 'até 30 de setembro', 'en-US': 'by September 30' },
  },
  {
    id: 'pr10k',
    title: { 'pt-BR': 'PR de 10 km abaixo de 47:00', 'en-US': '10 km PR under 47:00' },
    current: 48,
    target: 47,
    unit: { 'pt-BR': 'min', 'en-US': 'min' },
    deadline: { 'pt-BR': 'até a prova de novembro', 'en-US': 'by the November race' },
  },
]
